import { getCookie, setCookie } from '#pplx/frontend/cookies/provider.js';
import { useCallback, useEffect, useMemo, useState } from 'react';
const getImpressionsCount = (cueKey) => {
    const impressionsCountCookie = getCookie(cueKey);
    if (!impressionsCountCookie) {
        return 0;
    }
    const impressionsCount = parseInt(impressionsCountCookie);
    if (isNaN(impressionsCount)) {
        return 1; // cookie was set but malformed, consider as 1 impression
    }
    return impressionsCount;
};
const incrementImpressionsCount = (cueKey, newCount, expiresInDays) => {
    setCookie(cueKey, newCount.toString(), {
        expires: expiresInDays ?? 365,
    });
};
export const useCueImpressionLimit = ({ cueKey, impressionsLimit, enabled, expiresInDays, }) => {
    const [shouldShow, setShouldShow] = useState(false);
    const [currentCount, setCurrentCount] = useState(0);
    useEffect(() => {
        if (!enabled) {
            setShouldShow(false);
            return;
        }
        const impressionsCount = getImpressionsCount(cueKey);
        setCurrentCount(impressionsCount);
        if (impressionsCount < impressionsLimit) {
            setShouldShow(true);
            incrementImpressionsCount(cueKey, impressionsCount + 1, expiresInDays);
            setCurrentCount(impressionsCount + 1);
        }
    }, [cueKey, impressionsLimit, enabled, expiresInDays]);
    const setReachedImpressions = useCallback(() => {
        incrementImpressionsCount(cueKey, impressionsLimit, expiresInDays);
        setCurrentCount(impressionsLimit);
        setShouldShow(false);
    }, [cueKey, impressionsLimit, expiresInDays]);
    return useMemo(() => ({ shouldShow, currentCount, setReachedImpressions }), [shouldShow, currentCount, setReachedImpressions]);
};
//# sourceMappingURL=useCueImpressionLimit.js.map